import React, { useState } from "react";
import "./Commercial.css";
import Footer from "./Footer";

import img1 from "../assets/01-Compressor-housing.png";
import img2 from "../assets/02-manifold-side1.jpg";
import img4 from "../assets/04-cylinderhead-cover-side1.jpg";
import img5 from "../assets/05-gear-housing.jpg";
import img6 from "../assets/06-transmission-housing-g131-front.jpg";
import img7 from "../assets/07-flywheel-housing-side1.jpg";
import img9 from "../assets/09-oil-filter-body.jpg";
import img10 from "../assets/10-enginebracket-side1.jpg";
import img11 from "../assets/bracket_for_exhaust-side2.jpg";
import img12 from "../assets/12-1533-bracket.jpg";
import img14 from "../assets/14-steps-side1.jpg";
import img15 from "../assets/15-headlamp-side1.jpg";

const products = [
    {
        title: "Air Pipes and Manifolds",
        desc: "Provides provision for air passage and changing their directions to different elements in automobiles.",
        img: img2,
        type: "ICE",
        process: "GDC",
        weight: "500 gms to 5 Kg",
        category: "Engine",
    },
    {
        title: "Compressor Housing",
        desc: "Houses the compressor wheel in turbocharger assembly.",
        img: img1,
        type: "ICE",
        process: "GDC",
        weight: "1 to 6 Kg",
        category: "Engine",
        bg: "#E9EAEE",
    },
    {
        title: " Piston Cover(Brake Application)",
        desc: " Precision-engineered piston covers designed for reliable performance in commercial vehicle engines.",
        img: img4,
        type: "ICE",
        process: "HPDC",
        weight: "330 gms to 600 gms",
        category: "Engine",
    },
    {
        title: "Engine Brackets",
        desc: "Mounts the other assembly element to the engine.",
        img: img10,
        type: "ICE",
        process: "GDC",
        weight: "3 to 5 Kg",
        category: "Engine",
    },
    {
        title: "Flywheel Housing",
        desc: "Casing for flywheel.",
        img: img7,
        type: "ICE",
        process: "HPDC / GDC",
        weight: "GDC: 19-22 Kg, HPDC: 19-33 Kg",
        category: "Engine",
    },
    {
        title: "Oil Filter Body",
        desc: "To filter the lubrication oil and mounts the assembly components.",
        img: img9,
        type: "ICE",
        process: "HPDC",
        weight: "1.5 Kg",
        category: "Engine",
    },
    {
        title: "Gear Housing",
        desc: "Houses gear assembly in gear box.",
        img: img5,
        type: "ICE",
        process: "HPDC",
        weight: "20 Kg",
        category: "Transmission",
    },
    {
        title: "Transmission Housing",
        desc: "Houses gear assembly in transmission unit.",
        img: img6,
        type: "ICE",
        process: "HPDC",
        weight: "9 to 35 Kg",
        category: "Transmission",
    },
    {
        title: "Brackets for Exhaust System",
        desc: "Mounts the other assembly element to the exhaust system.",
        img: img11,
        type: "ICE",
        process: "GDC",
        weight: "4 to 4.7 Kg",
        category: "Structural",
    },
    {
        title: "Steps",
        desc: "Steps for people to enter cabin.",
        img: img14,
        type: "Cabin",
        process: "HPDC",
        weight: "1 to 4 Kg",
        category: "Structural",
    },
    {
        title: "Headlamp Carrier",
        desc: "Holder for head lamp of vehicle.",
        img: img15,
        type: "Cabin",
        process: "HPDC",
        weight: "1.5 Kg",
        category: "Structural",
    },
{
    title: "Air cleaner tank bracket",
    desc: " brackets to securely mount air filtration systems to the vehicle chassis.",
    img: img12,      
    type: "ICE",                
    process: "GDC",             
    weight: "0.9 to 5.7 Kg",    
    category: "Structural",            
},
];

function Commercial() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const categories = [
        { key: "Engine", title: "Engine", desc:"Capability to manufacture a range of aluminium engine components through GDC and HPDC from 330 g to 33 kg. Below are just a few examples: " },
        { key: "Transmission", title: "Transmission" },
        { key: "Structural", title: "Structural" },
        
    ];

    return (
        <section id="comm">
            <div className="cv-container">
                <h2 className="cv-title">Commercial Vehicle</h2>
                <div className="cv-underline"></div>

                <p className="cv-desc">
                In Commercial vehicles, We make robust, lightweight castings for enhanced durability and efficiency. 
                </p>

               {categories.map((category, catIndex) => (
    <div className="cv-category" key={category.key}>
        <h3 className="cv-category-title">
            {String(catIndex + 1).padStart(2, "0")}. {category.title}
        </h3>

                         {category.desc && (
                            <p className="cv-category-desc">
                                {category.desc}
                            </p>
                        )}

                        <div className="cv-grid">
                            {products
                                .filter((item) => item.category === category.key)
                                .map((item, index) => (
                                    <div className="cv-card" key={index}>
                                        <div
                                            className="cv-image"
                                            style={
                                                item.img
                                                    ? {
                                                          backgroundImage: `url(${item.img})`,
                                                          backgroundSize: "cover",
                                                          backgroundRepeat: "no-repeat",
                                                          backgroundPosition: "center",
                                                          backgroundColor:
                                                              item.bg || "#ffffff",
                                                      }
                                                    : {}
                                            }
                                        />

                                        <div className="cv-overlay">
                                            <h4>{item.title}</h4>
                                            <p>{item.desc}</p>

                                            <span
                                                className="cv-link"
                                                onClick={() =>
                                                    setSelectedProduct(item)
                                                }
                                            >
                                                View Specifications ↗
                                            </span>
                                        </div>

                                        <div className="cv-label">
                                            {item.title}
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                ))}

                {selectedProduct && (
                    <div
                        className="modal-backdrop"
                        onClick={() => setSelectedProduct(null)}
                    >
                        <div
                            className="modal-box"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <span
                                className="modal-close"
                                onClick={() => setSelectedProduct(null)}
                            >
                                ✕
                            </span>

                            <h5 className="modal-section-title">Overview</h5>

                            <div className="modal-overview">
                                <div
                                    className="modal-img"
                                    style={
                                        selectedProduct.img
                                            ? {
                                                  backgroundImage: `url(${selectedProduct.img})`,
                                                  backgroundSize: "cover",
                                                  backgroundRepeat: "no-repeat",
                                                  backgroundPosition: "center",
                                                  backgroundColor:
                                                      selectedProduct.bg ||
                                                      "#ffffff",
                                              }
                                            : {}
                                    }
                                ></div>

                                <div>
                                    <h3>{selectedProduct.title}</h3>
                                    <p>{selectedProduct.desc}</p>
                                </div>
                            </div>

                            <h5 className="modal-section-title">Features</h5>

                            <div className="modal-table">
                                <div>
                                    <span>ICE / BEV / Chasis / Cabin</span>
                                    <span>{selectedProduct.type}</span>
                                </div>

                                <div>
                                    <span>Casting Process Used</span>
                                    <span>{selectedProduct.process}</span>
                                </div>

                                <div>
                                    <span>Weight (Kg)</span>
                                    <span>{selectedProduct.weight}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <Footer />
        </section>
    );
}

export default Commercial;